import type { ReactNode } from "react";

interface LogoProps {
  /**
   * Hoogte van het woordmerk in pixels. Weglaten = CSS bepaalt de hoogte
   * (default 26px in .logo-mark, per context overstuurd zoals .logo--topbar).
   * Een inline style wint altijd van CSS, dus alleen zetten waar één vaste
   * maat echt gewenst is — zoals het inlogscherm.
   */
  height?: number;
  className?: string;
}

/**
 * Het RULIDO-woordmerk zoals het op de website staat, met "webmail" ernaast.
 *
 * Bewust het echte bestand en geen nagetekende SVG. Een eerdere versie tekende
 * het logo na met paden en een <text>-element; dat viel altijd net op — andere
 * letterafstand, en een verkeerd font zodra Overpass niet geladen was. Een merk
 * hoort overal identiek te zijn.
 *
 * Twee varianten (donker woordmerk voor lichte achtergrond, wit voor donkere)
 * die met CSS gewisseld worden. Geen JavaScript, dus geen knippering bij het
 * laden en geen verkeerde variant in de eerste frames.
 */
export function Logo({ height, className }: LogoProps): ReactNode {
  const style = height !== undefined ? { height } : undefined;
  return (
    <span className={className ? `logo ${className}` : "logo"} aria-label="RULIDO WEBMAIL">
      <img
        className="logo-mark logo-mark--licht"
        src="/rulido-logo.png"
        alt=""
        style={style}
        // Staat boven de vouw; lui laden zou het laten inpoppen.
        fetchPriority="high"
      />
      <img
        className="logo-mark logo-mark--donker"
        src="/rulido-logo-wit.png"
        alt=""
        style={style}
        fetchPriority="high"
      />
      <span className="logo-suffix" aria-hidden="true">webmail</span>
    </span>
  );
}
